import { v4 as uuid } from 'uuid';
import { toUUID } from '../../util/transform';
import { epoch, formatEpochAsDate, utc } from '../../util/datetime';
import type { IObjectiveApplicant } from './ObjectiveApplicant.interface';
import { YesNoOption } from '../global/YesNoOption.enum';

export default class ObjectiveApplicant implements IObjectiveApplicant {
  id: string;
  idContact: string;
  ageToRetire: string;
  response: YesNoOption;
  comments: string;
  dischargedDate: number;
  isChanged: boolean;

  getDischargedDate(timeZone, locale, localeFormat) {
    return this.dischargedDate
      ? formatEpochAsDate(this.dischargedDate, timeZone, locale, localeFormat)
      : 'N/A';
  }

  static build = (data: IObjectiveApplicant) => new ObjectiveApplicant(data);
  static blank = (idContact) => new ObjectiveApplicant({ id: uuid(), idContact });

  /**
   * Constructor
   * @param {IObjectiveApplicant} data
   */
  constructor(data?: IObjectiveApplicant, type) {
    this.id = toUUID(data?.id) || uuid();
    this.idContact = toUUID(data?.idContact);
    this.ageToRetire = data?.ageToRetire || '';
    this.response =
      type === 'bankruptcy'
        ? YesNoOption.of(data?.response?.name || `b${data?.response?.toString()}`)
        : YesNoOption.of(data?.response?.name || data?.response?.toString());
    this.comments = data?.comments || '';
    this.dischargedDate = data?.dischargedDate ? epoch(utc(data?.dischargedDate)) : 0;
    this.isChanged = data?.isChanged === true;
  }
}
